import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeBuyingCenterRoleCreate,
  detail: routeBuyingCenterRoleDetail,
  home: routeBuyingCenterRoleSettingsHome,
  root: routeBuyingCenterRoleSettingsRoot,
} = createDoctypeRoutes({
  createName: 'new-buying-center-role',
  createPath: 'new-buying-center-role',
  detailName: 'buying-center-role-detail',
  doctype: DOCTYPES.TW_BUYING_CENTER_ROLE,
  homeName: 'buying-center-role-settings-home',
  path: 'buying-center-role',
  views: {
    create: async () =>
      await import(
        '@/components/viewsExternal/settings/sales/twBuyingCenterRoles/AddTwBuyingCenterRole.vue'
      ),
    detail: async () =>
      await import(
        '@/components/viewsExternal/settings/sales/twBuyingCenterRoles/ViewTwBuyingCenterRole.vue'
      ),
    list: async () =>
      await import('@/components/viewsExternal/settings/sales/ViewSalesSettings.vue'),
  },
})

export {
  routeBuyingCenterRoleCreate,
  routeBuyingCenterRoleDetail,
  routeBuyingCenterRoleSettingsHome,
  routeBuyingCenterRoleSettingsRoot,
}
